import {defineAsyncComponent} from 'vue';

const MB01_TT344 = defineAsyncComponent(() => import('@/views/report/formParam/MB01_TT344.vue'));
const MB01_TT344_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB01_TT344_ViewSummary.vue'),
);
const MB01_PTCBV = defineAsyncComponent(() => import('@/views/report/formParam/MB01_PTCBV.vue'));
const MB01_PTC_VanBan = defineAsyncComponent(() => import('@/views/report/formParam/MB01_PTC_VanBan.vue'));
const MB31a_STCKH = defineAsyncComponent(() => import('@/views/report/formParam/MB31a_STCKH.vue'));
const MB12_1_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB12_1_TT342.vue'));
const MB12_1_TT342_QN = defineAsyncComponent(() => import('@/views/report/formParam/MB12_1_TT342_QN.vue'));
const MB12_1_CQSN = defineAsyncComponent(() => import('@/views/report/formParam/MB12_1_CQSN.vue'));

const MB12_1_TT342_ViewSummary_CQSN = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_1_TT342_ViewSummary_CQSN.vue'),
);
const MB12_1_TT342_ViewExamine_CQSN = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_1_TT342_ViewExamine_CQSN.vue'),
);

const MB12_1_TT342_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB12_1_TT342_PTC.vue'));
const MB12_3_TT342_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB12_3_TT342_PTC.vue'));
const MB12_4_TT342_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB12_4_TT342_PTC.vue'));
const MB12_5_TT342_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB12_5_TT342_PTC.vue'));
const MB12_5_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB12_5_TT342_STC.vue'));
const MB12_1_TT342_ViewSummary_HCSN = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_1_TT342_ViewSummary_HCSN.vue'),
);
const MB12_1_TT342_ViewSummary_HCSN_QN = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_1_TT342_ViewSummary_HCSN_QN.vue'),
);

const MB12_1_TT342_KH = defineAsyncComponent(() => import('@/views/report/formParam/MB12_1_TT342_KH.vue'));
const MB12_1_TT342_KH_DVCQ = defineAsyncComponent(() => import('@/views/report/formParam/MB12_1_TT342_KH_DVCQ.vue'));

const MB12_2_TT342_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB12_2_TT342_PTC.vue'));

const MB12_2_TT342_ViewSummary_HCSN = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_2_TT342_ViewSummary_HCSN.vue'),
);

const MB12_2_TT342_CQSN = defineAsyncComponent(() => import('@/views/report/formParam/MB12_2_TT342_CQSN.vue'));

const MB12_2_TT342_HCSN_KH = defineAsyncComponent(() => import('@/views/report/formParam/MB12_2_TT342_HCSN_KH.vue'));

const MB12_2_TT342_ViewKH_HCSN = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_2_TT342_ViewKH_HCSN.vue'),
);

const MB12_2_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB12_2_TT342.vue'));

const MB02_TT344 = defineAsyncComponent(() => import('@/views/report/formParam/MB02_TT344.vue'));
const MB02_TT344_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB02_TT344_ViewSummary.vue'),
);

// Biểu 16 - dự toán 3 năm - lập DT toàn ngành
const MB16_TT69_ThreeYear_ViewSummary_DVCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB16_TT69_ThreeYear_ViewSummary_DVCQ.vue'),
);
// Biểu 16 - báo cáo
const MB16_TT69_ThreeYear_DVCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB16_TT69_ThreeYear_ViewSummary_DVCQ.vue'),
);

// Biểu 13 - dự toán 3 năm - lập DT toàn ngành
const MB13_TT69_ThreeYear_ViewSummary_DVCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_TT69_ThreeYear_ViewSummary_DVCQ.vue'),
);
// Biểu 13 - báo cáo
const MB13_TT69_ThreeYear_DVCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_TT69_ThreeYear_ViewSummary_DVCQ.vue'),
);

const MB03_TT344 = defineAsyncComponent(() => import('@/views/report/formParam/MB03_TT344.vue'));
const MB03_TT344_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB03_TT344_ViewSummary.vue'),
);

const MB15_2_TML = defineAsyncComponent(() => import('@/views/report/formParam/MB15_2_TML.vue'));

const MB05_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB05_TT342.vue'));

const MB05_TT342_KH = defineAsyncComponent(() => import('@/views/report/formParam/MB05_TT342_KH.vue'));

const MB07_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB07_TT342.vue'));

const MB07_KH_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB07_KH_TT342.vue'));

const MB31_TT342_ViewSummary_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB31_TT342_ViewSummary_PTC.vue'),
);

const MB31_TT342_ViewSummary_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB31_TT342_ViewSummary_STC.vue'),
);

const MB31_TT342_ViewReport_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB31_TT342_ViewReport_STC.vue'),
);

const MB31_TT342_PTCKH = defineAsyncComponent(() => import('@/views/report/formParam/MB31_TT342_PTCKH.vue'));

const MB31_TT342_ViewReport_STC_KH = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB31_TT342_ViewReport_STC_KH.vue'),
);

const MB38_ND31_STCKH = defineAsyncComponent(() => import('@/views/report/formParam/MB38_ND31_STCKH.vue'));
const BaseReportParamDefault = defineAsyncComponent(() =>
  import('@/views/report/base/popup/BaseReportParamDefault.vue'),
);
const MB16_PTC_Estimte_by_field = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB16_PTC_Estimte_by_field.vue'),
);

const MB16_PTC_Estimte_by_field_BC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB16_PTC_Estimte_by_field_BC.vue'),
);

const MB02_TT342_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB02_TT342_ViewSummary.vue'),
);

const MB07_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB07_STC.vue'));

const MB08_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB08_STC.vue'));

const MB27_TT342_ViewSummary_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB27_TT342_ViewSummary_PTC.vue'),
);

const MB27_TT342_ViewReport_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB27_TT342_ViewSummary_PTC.vue'),
);

const MB12_3_ViewSummary_HCSNCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_3_ViewSummary_HCSNCQ.vue'),
);

const MB12_3_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB12_3_TT342_STC.vue'));

const MB12_4_ViewSummary_HCSNCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_4_ViewSummary_HCSNCQ.vue'),
);
const MB04_TT69_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB04_TT69_STC.vue'));
const MB04_TT69_ViewSummary_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB04_TT69_ViewSummary_STC.vue'),
);

const MB12_5_ViewSummary_HCSNCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_5_ViewSummary_HCSNCQ.vue'),
);

//#region Phòng tài chính Hàm tân
// biểu 09 PTC Ham tan
const MB09_PTCHT = defineAsyncComponent(() => import('@/views/report/formParam/PTC_HamTan_ReportParam.vue'));
// biểu 07 PTC Ham tan
const MB07_PTCHT = defineAsyncComponent(() => import('@/views/report/formParam/PTC_HamTan_ReportParam.vue'));

const MB01_PTCBV_ViewSummary_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB01_PTCBV_ViewSummary_PTC.vue'),
);

const MB29_2_TT342_ViewSummary_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB29_2_TT342_ViewSummary_PTC.vue'),
);

const MB08ReportPopupShowPercent = defineAsyncComponent(() =>
  import('@/views/report/popupcustom/MB08ReportPopupShowPercent.vue'),
);
const MB291ReportPopupShowEstimate = defineAsyncComponent(() =>
  import('@/views/report/popupcustom/MB291ReportPopupShowEstimate.vue'),
);

const MB11_ND31_STCReportPopup = defineAsyncComponent(() =>
  import('@/views/report/popupcustom/MB11_ND31_STCReportPopup.vue'),
);
const MB32a_STCKHReportPopup = defineAsyncComponent(() =>
  import('@/views/report/popupcustom/MB32a_STCKHReportPopup.vue'),
);
const MB32_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB32_TT342.vue'));

const MB32_TT342_ViewSummary_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB32_TT342_ViewSummary_STC.vue'),
);
const MB32_TT342_ViewReport_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB32_TT342_ViewReport_STC.vue'),
);

const MB32_TT342_ViewSummary_STC_KH = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB32_TT342_ViewSummary_STC_KH.vue'),
);
const MB32_TT342_ViewReport_STC_KH = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB32_TT342_ViewReport_STC_KH.vue'),
);
const MB32_TT342_STC_KH_Popup = defineAsyncComponent(() =>
  import('@/views/report/popupcustom/MB32_TT342_STC_KH_Popup.vue'),
);

const MB17_TT342_ViewSummary_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB17_TT342_ViewSummary_PTC.vue'),
);

const MB17_ND31_ViewReport_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB17_ND31_ViewReport_PTC.vue'),
);

const MB12_ND31_ViewSummary_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_ND31_ViewSummary_PTC.vue'),
);
const MB12_ND31_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB12_ND31_PTC.vue'));

const MB12_ND31_ViewReport_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_ND31_ViewReport_STC.vue'),
);

const MB12_ND31_ViewSummary_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_ND31_ViewSummary_STC.vue'),
);

const MB14_ND31_ViewReport_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB14_ND31_ViewReport_STC.vue'),
);

const MB14_ND31_ViewSummary_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB14_ND31_ViewSummary_STC.vue'),
);

const MB35_ND31_ViewReport_STCKH = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB35_ND31_ViewReport_STCKH.vue'),
);

const MB35_ND31_ViewSummary_STCKH = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB35_ND31_ViewSummary_STCKH.vue'),
);

const MB32_TT342_BC = defineAsyncComponent(() => import('@/views/report/formParam/MB32_TT342_BC.vue'));
const MB06_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB06_PTC.vue'));
const MB06_HCSNCQ = defineAsyncComponent(() => import('@/views/report/formParam/MB06_HCSNCQ.vue'));
const MB06_TT342_KH_HCSNCQ = defineAsyncComponent(() => import('@/views/report/formParam/MB06_TT342_KH_HCSNCQ.vue'));
const MB06_HCSNCQ_TH = defineAsyncComponent(() => import('@/views/report/formParam/MB06_HCSNCQ_TH.vue'));
const MB06_HCSNCQ_KT = defineAsyncComponent(() => import('@/views/report/formParam/MB06_HCSNCQ_KT.vue'));
const MB06_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB06_TT342_STC.vue'));
const ReportKH_KPTL73_STC_SUMMARY = defineAsyncComponent(() =>
  import('@/views/report/formParam/ReportKH_KPTL73_STC_SUMMARY.vue'),
);
const MB05_HamTan = defineAsyncComponent(() => import('@/views/report/formParam/MB05_HamTan.vue'));

const MB13_ND31_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB13_ND31_PTC.vue'));
const MB13_ND31_ViewSummary_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_ND31_ViewSummary_PTC.vue'),
);
const MB13_ND31_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB13_ND31_STC.vue'));
const MB13_ND31_ViewSummary_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_ND31_ViewSummary_STC.vue'),
);

const MB11_ND31_NDCP_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB11_ND31_NDCP_STC.vue'));

const MB11_ND31_NDCP_STC_Summary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB11_ND31_NDCP_STC_Summary.vue'),
);

const BaseReportPopupShowHide = defineAsyncComponent(() =>
  import('@/views/report/base/popup/BaseReportPopupShowHide.vue'),
);

const BaseReportPreviewPrint = defineAsyncComponent(() =>
  import('@/views/report/base/popup/BaseReportPreviewPrint.vue'),
);

const SummaryEstimateArrgrateViewReportPTCModeRevenue = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/tabs/popup/SummaryEstimateArrgrateViewReportPTCModeRevenue.vue'
  ),
);
const SummaryEstimateArrgrateViewReportSTCModeRevenue = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/popup/SummaryEstimateArrgrateViewReportSTCModeRevenue.vue'),
);

const SummaryEstimateArrgrateSectorWideViewReport = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/tabMenu/tabs/popup/SummaryEstimateArrgrateSectorWideViewReport.vue'),
);

const SubmitEstimateArrgrateSectorWideViewReport = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/tabMenu/tabs/popup/SubmitEstimateArrgrateSectorWideViewReport.vue'),
);

const SummaryEstimateArrgrateViewReportPTCModeSummary = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/tabs/popup/SummaryEstimateArrgrateViewReportPTCModeSummary.vue'
  ),
);
const SummaryEstimateArrgrateViewReportSTCModeDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/popup/SummaryEstimateArrgrateViewReportSTCModeDetail.vue'),
);
const SummaryEstimateArrgrateViewReportSTCModeSummary = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/popup/SummaryEstimateArrgrateViewReportSTCModeSummary.vue'),
);
const SummaryEstimateDistrictViewReportSTCModeSummary = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/popup/SummaryEstimateDistrictViewReportSTCModeSummary.vue'),
);
const SummaryEstInitialExplanationDetailPopup = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/popup/SummaryEstInitialExplanationDetailPopup.vue'),
);
const SummaryEstimateArrgrateViewReportPTCModeDetail = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/tabs/popup/SummaryEstimateArrgrateViewReportPTCModeDetail.vue'
  ),
);

const SummaryEstimateArrgrateViewReportPTCModeExpense = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/tabs/popup/SummaryEstimateArrgrateViewReportPTCModeExpense.vue'
  ),
);

const SummaryEstimateArrgrateViewReportPTCModeBalance = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/tabs/popup/SummaryEstimateArrgrateViewReportPTCModeBalance.vue'
  ),
);

const SummaryEstimateArrgrateViewReportSTCModeExpense = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/popup/SummaryEstimateArrgrateViewReportSTCModeExpense.vue'),
);

const SummaryEstimateArrgrateViewReportSTCModeBalance = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/popup/SummaryEstimateArrgrateViewReportSTCModeBalance.vue'),
);

const SummaryEstimateArrgrateViewReportCQSNModeDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/popup/SummaryEstimateArrgrateViewReportCQSNModeDetail.vue'),
);

const SummaryEstimateArrgrateViewReportCQSNModeSummary = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryBeginYear/popup/SummaryEstimateArrgrateViewReportCQSNModeSummary.vue'),
);

const SummaryEstimateArrgrateViewReportDVXModeRevenue = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/tabs/popup/SummaryEstimateArrgrateViewReportDVXModeRevenue.vue'
  ),
);

const SummaryEstimateArrgrateViewReportDVXModeExpense = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/tabs/popup/SummaryEstimateArrgrateViewReportDVXModeExpense.vue'
  ),
);

const SummaryEstimateArrgrateViewReportDVXModeBalance = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/tabs/popup/SummaryEstimateArrgrateViewReportDVXModeBalance.vue'
  ),
);
const MB08_Other_Summary_PTCHT = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB08_Other_Summary_PTCHT.vue'),
);
const MB08_Other_PTCHT = defineAsyncComponent(() => import('@/views/report/formParam/MB08_Other_PTCHT.vue'));

const MB13_7_TT342_HCSN3 = defineAsyncComponent(() => import('@/views/report/formParam/MB13_7_TT342_HCSN3.vue'));
const MB13_7_TT342_Summary_HCSN3 = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_7_TT342_Summary_HCSN3.vue'),
);

const MB13_8_TT342_HCSN3 = defineAsyncComponent(() => import('@/views/report/formParam/MB13_8_TT342_HCSN3.vue'));
const MB13_8_TT342_Summary_HCSN3 = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_8_TT342_Summary_HCSN3.vue'),
);

const MB13_9_TT342_Summary_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_9_TT342_Summary_PTC.vue'),
);
const MB13_9_TT342_Summary_CQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_9_TT342_Summary_CQ.vue'),
);

const MB13_9_TT342_Report_CQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_9_TT342_Report_CQ.vue'),
);

const MB13_9_TT342_Audit_CQ = defineAsyncComponent(() => import('@/views/report/formParam/MB13_9_TT342_Audit_CQ.vue'));
const MB13_9_TT342_Audit_District_Summary_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_9_TT342_Audit_District_Summary_PTC.vue'),
);

const MBThuSN_Other_HCSN3_HamTan = defineAsyncComponent(() =>
  import('@/views/report/formParam/MBThuSN_Other_HCSN3_HamTan.vue'),
);
const MBThuSN_Summary_Other_HCSN3_HamTan = defineAsyncComponent(() =>
  import('@/views/report/formParam/MBThuSN_Summary_Other_HCSN3_HamTan.vue'),
);

const MB13_2_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB13_2_TT342.vue'));
const MB13_2_QN_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB13_2_QN_TT342.vue'));

const MB13_9_TT342_HCSN3 = defineAsyncComponent(() => import('@/views/report/formParam/MB13_9_TT342_HCSN3.vue'));
const MB14_TT342_Audit_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB14_TT342_Audit_PTC.vue'));

const MBCTMTQG_PTCHT = defineAsyncComponent(() => import('@/views/report/formParam/MBCTMTQG_PTCHT.vue'));

const MB13_9_TT342_Summary_HCSN3 = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_9_TT342_Summary_HCSN3.vue'),
);

const MB04_ViewSymmetrical_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB04_ViewSymmetrical_PTC.vue'),
);

const MB23_ViewSummary_TT342 = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB23_ViewSummary_TT342.vue'),
);

const MB12_3_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB12_3_TT342.vue'));
const MB12_3_TT342_Report_HCSN3_KH = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_3_TT342_Report_HCSN3_KH.vue'),
);
const MB12_3_TT342_Summary_HCSN3_KH = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_3_TT342_Summary_HCSN3_KH.vue'),
);
const MB12_3_TT342_ViewReport_HCSNCQ_KH = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_3_TT342_ViewReport_HCSNCQ_KH.vue'),
);
const MB12_3_TT342_ViewSummary_HCSNCQ_KH = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_3_TT342_ViewSummary_HCSNCQ_KH.vue'),
);
const MB12_3_TT342_AuditSummary_HCSNCQ_KH = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_3_TT342_AuditSummary_HCSNCQ_KH.vue'),
);

const MB12_4_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB12_4_TT342.vue'));

const MB12_5_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB12_5_TT342.vue'));

const MB13_2_Report_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB13_2_Report_TT342.vue'));

const MB13_2_QN_Report_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB13_2_QN_Report_TT342.vue'));

const MB35_Report_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB35_Report_TT342.vue'));

const MB35_Report_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB35_Report_TT342_STC.vue'));

const MB12_3_TT342_ViewSummary_HCSNC3 = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_3_TT342_ViewSummary_HCSNC3.vue'),
);

const MB12_4_TT342_ViewSummary_HCSNC3 = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_4_TT342_ViewSummary_HCSNC3.vue'),
);

const MB12_4_KH_ViewReport_HCSNCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_4_KH_ViewReport_HCSNCQ.vue'),
);

const MB12_4_KH_TT342_DVCQ = defineAsyncComponent(() => import('@/views/report/formParam/MB12_4_KH_TT342_DVCQ.vue'));

const MB12_4_KH_TT342_Summary_HCSNC3 = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_4_KH_TT342_Summary_HCSNC3.vue'),
);

const MB12_4_KH_ViewSummary_HCSNCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_4_KH_ViewSummary_HCSNCQ.vue'),
);

const MB12_4_TT342_KH = defineAsyncComponent(() => import('@/views/report/formParam/MB12_4_TT342_KH.vue'));

const B06_ViewSummary_PTC = defineAsyncComponent(() => import('@/views/report/formParam/B06_ViewSummary_PTC.vue'));

const MB05_TT342_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB05_TT342_ViewSummary.vue'),
);

const MB07_TT342_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB07_TT342_ViewSummary.vue'),
);

const MB07_KH_TT342_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB07_KH_TT342_ViewSummary.vue'),
);

const MB12_5_TT342_ViewSummary_HCSNC3 = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_5_TT342_ViewSummary_HCSNC3.vue'),
);

const TotalEstimateHCSNReportModeSummary = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/tabs/popup/TotalEstimateHCSNReportModeSummary.vue'),
);

const RequestDetailHCSNReport = defineAsyncComponent(() => import('@/views/examine/tab/RequestDetailHCSNReport.vue'));

const RequestDetailSCQReport = defineAsyncComponent(() => import('@/views/examine/tab/RequestDetailSCQReport.vue'));

const TotalEstimateHCSNReportModeDetail = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/tabs/popup/TotalEstimateHCSNReportModeDetail.vue'),
);
const MB14_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB14_TT342.vue'));

const MB08_TT342_ViewSummary_XHT = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB08_TT342_ViewSummary_XHT.vue'),
);
// Biểu 13.5
const MBS13_5_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MBS13_5_TT342.vue'));
const MB13_5_TT342_ViewSummary_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_5_TT342_ViewSummary_PTC.vue'),
);

// Biểu 13.8 - PTC
const ViewSummary_Balance_MB13_8_TT342_HCSN_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_5_TT342_ViewSummary_PTC.vue'),
);
const ViewSummary_Checking_MB13_8_TT342_HCSN_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_5_TT342_ViewSummary_PTC.vue'),
);
const ViewSummary_Report_MB13_8_TT342_HCSN_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_5_TT342_ViewSummary_PTC.vue'),
);
const ViewSummary_Report_MB13_8_TT342_HCSN_CQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_8_TT342_ViewReport_CQ.vue'),
);
const ViewSummary_MB13_8_TT342_HCSN_CQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_8_TT342_ViewSummary_CQ.vue'),
);
const MB13_8_TT342_ViewAudit_CQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_8_TT342_ViewAudit_CQ.vue'),
);

const B11_1_TT342_HCSN = defineAsyncComponent(() => import('@/views/report/formParam/B11_1_TT342_HCSN.vue'));

const B13_10_TT342_ViewReport_HCSN = defineAsyncComponent(() =>
  import('@/views/report/formParam/B13_10_TT342_ViewReport_HCSN.vue'),
);

const MB08_TT342_ViewReport_XHT = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB08_TT342_ViewReport_XHT.vue'),
);

const MB11_1_DTC_TH = defineAsyncComponent(() => import('@/views/report/formParam/MB11_1_DTC_TH.vue'));

const MB13_10_TT342_ViewSummary_HCSN = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_10_TT342_ViewSummary_HCSN.vue'),
);

const MB14_CSTDT = defineAsyncComponent(() => import('@/views/report/formParam/MB14_CSTDT.vue'));
const MB14_CSTDT_BC = defineAsyncComponent(() => import('@/views/report/formParam/MB14_CSTDT_BC.vue'));
const MB13_9_TT342_Report_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_9_TT342_Report_PTC.vue'),
);

const MB_TH_CTMTQG_PTCHT = defineAsyncComponent(() => import('@/views/report/formParam/MB_TH_CTMTQG_PTCHT.vue'));

// in 13.2 ở tổng hợp kiểm tra
const MB13_2_ViewSummary_Check_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_2_ViewSummary_Check_PTC.vue'),
);

// in 13.2 ở tổng hợp sau lập
const MB13_2_ViewSummary_Create_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_2_ViewSummary_Create_PTC.vue'),
);
// in 13.2 ở báo cáo
const MB13_2_ViewReport_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB13_2_ViewReport_PTC.vue'));

const MB01_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB01_PTC.vue'));
const MB31_TT342_ViewReport_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB31_TT342_ViewReport_PTC.vue'),
);

const MB15_ND31_ViewReport_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB15_ND31_ViewReport_PTC.vue'),
);
const MB15_ND31_ViewSummary_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB15_ND31_ViewSummary_PTC.vue'),
);

const MB04_HDXNK_ViewReport_PTCHT = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB04_HDXNK_ViewReport_PTCHT.vue'),
);
const MB04_HDXNK_ViewSummary_PTCHT = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB04_HDXNK_ViewSummary_PTCHT.vue'),
);
const MB29_1_ViewEstimate_PTCHT = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB29_1_ViewEstimate_PTCHT.vue'),
);

const MB29_2_ViewEstimate_PTCHT = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB29_2_ViewEstimate_PTCHT.vue'),
);
const MBS26_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MBS26_TT342.vue'));

const MB14_TT342_HCSN_TH = defineAsyncComponent(() => import('@/views/report/formParam/MB14_TT342_HCSN_TH.vue'));
const MB01_NT_HCSN3 = defineAsyncComponent(() => import('@/views/report/formParam/MB01_NT_HCSN3.vue'));
const MB01_NT_HCSN3_SummaryEstimate = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB01_NT_HCSN3_SummaryEstimate.vue'),
);
const MB01_NT_CQSN = defineAsyncComponent(() => import('@/views/report/formParam/MB01_NT_CQSN.vue'));
const MB01_NT_CQSN_SummaryEstimate = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB01_NT_CQSN_SummaryEstimate.vue'),
);
const MB01_NT_CQSN_AuditEstimate = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB01_NT_CQSN_AuditEstimate.vue'),
);
const AllocationPublishingReportSCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/AllocationPublishingReportSCQ.vue'),
);

const MB14_TT342_HCSN_BC = defineAsyncComponent(() => import('@/views/report/formParam/MB14_TT342_HCSN_BC.vue'));
const MB17_TY_HCSN3 = defineAsyncComponent(() => import('@/views/report/formParam/MB17_TY_HCSN3.vue'));
const MB18_TY_HCSN3 = defineAsyncComponent(() => import('@/views/report/formParam/MB18_TY_HCSN3.vue'));
const MB17_TY_HCSN3_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB17_TY_HCSN3_ViewSummary.vue'),
);
const MB18_TY_HCSN3_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB18_TY_HCSN3_ViewSummary.vue'),
);
const MB13_1_HCSNC3_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_1_HCSNC3_ViewSummary.vue'),
);
const MB13_1_TC = defineAsyncComponent(() => import('@/views/report/formParam/MB13_1_TC.vue'));

const MB11_1_TT342_ViewSummary_DVCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB11_1_TT342_ViewSummary_DVCQ.vue'),
);

const MB11_1_TT342_ViewReport_DVCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB11_1_TT342_ViewReport_DVCQ.vue'),
);

const MB13_1_HCSNC3 = defineAsyncComponent(() => import('@/views/report/formParam/MB13_1_HCSNC3.vue'));
const MB13_1_HCSNC3QN = defineAsyncComponent(() => import('@/views/report/formParam/MB13_1_HCSNC3QN.vue'));

const MB29_1_TT342_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB29_1_TT342_PTC.vue'));
const MB29_2_TT342_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB29_2_TT342_PTC.vue'));

const MB29_2_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB29_2_TT342_STC.vue'));

const MB29_2_TT342_ViewSummary_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB29_2_TT342_ViewSummary_STC.vue'),
);

const MB05_TT342_ViewSummary_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB05_TT342_ViewSummary_PTC.vue'),
);

const MB16_test_base_new = defineAsyncComponent(() => import('@/views/report/formParam/MB16_test_base_new.vue'));
const MB14_ND31_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB14_ND31_PTC.vue'));

// in 13.7 hàm tân ở tổng hợp kiểm tra
const MB13_7_ViewExam_XHT = defineAsyncComponent(() => import('@/views/report/formParam/MB13_7_ViewExam_XHT.vue'));

// in 13.7 hàm tân ở tổng hợp sau lập
const MB13_7_ViewSummary_XHT = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_7_ViewSummary_XHT.vue'),
);

// in 13.7 hàm tân ở menu báo cáo
const MB13_7_ViewReport_XHT = defineAsyncComponent(() => import('@/views/report/formParam/MB13_7_ViewReport_XHT.vue'));

const MB07_TT342_ViewSummary_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB07_TT342_ViewSummary_PTC.vue'),
);

const MB01_THL_PTCVB = defineAsyncComponent(() => import('@/views/report/formParam/MB01_THL_PTCVB.vue'));

const MB13_1_TT342_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB13_1_TT342_PTC.vue'));

const MLHT_HG_HCSNC3 = defineAsyncComponent(() => import('@/views/report/formParam/MLHT_HG_HCSNC3.vue'));

const MB05_TT342_HCSNCQ = defineAsyncComponent(() => import('@/views/report/formParam/MB05_TT342_HCSNCQ.vue'));

const MB05_TT342_KH_HCSNCQ = defineAsyncComponent(() => import('@/views/report/formParam/MB05_TT342_KH_HCSNCQ.vue'));

// Biểu mẫu Dự toán nâng lương thường xuyên
const NLTX_HG_HCSN = defineAsyncComponent(() => import('@/views/report/formParam/NLTX_HG_HCSN.vue'));

const CCTL_HG_LDT_HCSN = defineAsyncComponent(() => import('@/views/report/formParam/CCTL_HG_LDT_HCSN.vue'));

// mẫu biểu 14 view Tổng hợp HCSN chủ quản
const MB14_TT342_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB14_TT342_ViewSummary.vue'),
);
const MB05_TT342_ViewSummary_HCSNCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB05_TT342_ViewSummary_HCSNCQ.vue'),
);
const MB05_TT342_ViewSummaryAudit_HCSNCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB05_TT342_ViewSummaryAudit_HCSNCQ.vue'),
);
const MB07_TT342_HCSNCQ = defineAsyncComponent(() => import('@/views/report/formParam/MB07_TT342_HCSNCQ.vue'));
const MB07_KH_TT342_HCSNCQ = defineAsyncComponent(() => import('@/views/report/formParam/MB07_KH_TT342_HCSNCQ.vue'));
const MB07_TT342_HCSNCQ_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB07_TT342_HCSNCQ_ViewSummary.vue'),
);
const MB07_KH_TT342_HCSNCQ_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB07_KH_TT342_HCSNCQ_ViewSummary.vue'),
);
const MB07_TT342_HCSNCQ_ViewExamine = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB07_TT342_HCSNCQ_ViewExamine.vue'),
);

const MB07_KH_TT342_HCSNCQ_ViewExamine = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB07_KH_TT342_HCSNCQ_ViewExamine.vue'),
);

const MB13_1_ViewSummary_Check = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_1_ViewSummary_Check.vue'),
);
const MB13_1_ViewSummary_CQ = defineAsyncComponent(() => import('@/views/report/formParam/MB13_1_ViewSummary_CQ.vue'));
const MB13_1_ViewReport_CQ = defineAsyncComponent(() => import('@/views/report/formParam/MB13_1_ViewReport_CQ.vue'));
const MB13_1_ViewReport_CQ_QN = defineAsyncComponent(() => import('@/views/report/formParam/MB13_1_ViewReport_CQ_QN.vue'));
const MB13_11_KH_CQ = defineAsyncComponent(() => import('@/views/report/formParam/MB13_11_KH_CQ.vue'));
const MB13_1_TT342_STCViewSummaryAudit = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_1_TT342_STCViewSummaryAudit.vue'),
);
const MB13_1_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB13_1_TT342_STC.vue'));
const MB13_1_TT342_STCQN = defineAsyncComponent(() => import('@/views/report/formParam/MB13_1_TT342_STCQN.vue'));


const MB13_1_TT342_STC_ViewEstimateSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_1_TT342_STC_ViewEstimateSummary.vue'),
);
const MB14_TT342_ViewReport = defineAsyncComponent(() => import('@/views/report/formParam/MB14_TT342_ViewReport.vue'));
const B01_STCHG = defineAsyncComponent(() => import('@/views/report/formParam/B01_STCHG.vue'));
const B02_STCHG = defineAsyncComponent(() => import('@/views/report/formParam/B02_STCHG.vue'));
const BM03_STCHGService = defineAsyncComponent(() => import('@/views/report/formParam/BM03_STCHGService.vue'));

// Giai đoạn 3 năm - thông tư 69 menu báo cáo
const MB15_TY_HCSNC3 = defineAsyncComponent(() => import('@/views/report/formParam/MB15_TY_HCSNC3.vue'));
const MB16_TY_HCSNC3 = defineAsyncComponent(() => import('@/views/report/formParam/MB16_TY_HCSNC3.vue'));
const MB19_TY_HCSNC3 = defineAsyncComponent(() => import('@/views/report/formParam/MB19_TY_HCSNC3.vue'));
// Giai đoạn 3 năm - thông tư 69 view tổng hợp
const MB15_TY_HCSNC3_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB15_TY_HCSNC3_ViewSummary.vue'),
);
const MB16_TY_HCSNC3_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB16_TY_HCSNC3_ViewSummary.vue'),
);
const MB19_TY_HCSNC3_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB19_TY_HCSNC3_ViewSummary.vue'),
);
const MB15_1_TT342_HCSN = defineAsyncComponent(() => import('@/views/report/formParam/MB15_1_TT342_HCSN.vue'));
const MB15_1_TT342_HCSN_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB15_1_TT342_HCSN_ViewSummary.vue'),
);
const MB15_1_TT342_DVCQ_ViewExamine = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB15_1_TT342_DVCQ_ViewExamine.vue'),
);
const MB15_1_TT342_DVCQ_TH = defineAsyncComponent(() => import('@/views/report/formParam/MB15_1_TT342_DVCQ_TH.vue'));
const MB15_1_DVCQ = defineAsyncComponent(() => import('@/views/report/formParam/MB15_1_DVCQ.vue'));
const MB15_2_DVCQ = defineAsyncComponent(() => import('@/views/report/formParam/MB15_2_DVCQ.vue'));
const MB15_2_DVCQ_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB15_2_DVCQ_ViewSummary.vue'),
);
const MB15_2_DVCQ_ViewAudit = defineAsyncComponent(() => import('@/views/report/formParam/MB15_2_DVCQ_ViewAudit.vue'));
const MB14_TT342_ViewAudit = defineAsyncComponent(() => import('@/views/report/formParam/MB14_TT342_ViewAudit.vue'));
const MB15_2_HCSN = defineAsyncComponent(() => import('@/views/report/formParam/MB15_2_HCSN.vue'));
const MB15_2_HCSN_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB15_2_HCSN_ViewSummary.vue'),
);
const MB13_2_TT342_DVCQ = defineAsyncComponent(() => import('@/views/report/formParam/MB13_2_TT342_DVCQ.vue'));
const MB13_2_TT342_DVCQ_QN = defineAsyncComponent(() => import('@/views/report/formParam/MB13_2_TT342_DVCQ_QN.vue'));
const MB13_2_TT342_DVCQ_ViewAudit = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_2_TT342_DVCQ_ViewAudit.vue'),
);
const MB13_2_TT342_DVCQ_ViewAudit_QN = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_2_TT342_DVCQ_ViewAudit_QN.vue'),
);
const MB13_1_TT342_DVCQ_ViewExamine = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_1_TT342_DVCQ_ViewExamine.vue'),
);
const MB13_1_TT342_DVCQ_ViewExamine_QN = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_1_TT342_DVCQ_ViewExamine_QN.vue'),
);
const MB13_2_TT342_DVCQ_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_2_TT342_DVCQ_ViewSummary.vue'),
);
const MB15_1_TT342_STC_TH = defineAsyncComponent(() => import('@/views/report/formParam/MB15_1_TT342_STC_TH.vue'));
const MB15_1_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB15_1_TT342_STC.vue'));
const MB15_2_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB15_2_TT342_STC.vue'));
const MB13_2_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB13_2_TT342_STC.vue'));
const MB13_2_TT342_STC_TH = defineAsyncComponent(() => import('@/views/report/formParam/MB13_2_TT342_STC_TH.vue'));
const MB13_2_TT342_STC_Summary_Audit = defineAsyncComponent(() => import('@/views/report/formParam/MB13_2_TT342_STC_Summary_Audit.vue'));
const MB13_2_TT342_STC_QN_Summary_Audit = defineAsyncComponent(() => import('@/views/report/formParam/MB13_2_TT342_STC_QN_Summary_Audit.vue'));

const MBTSN_CQDB = defineAsyncComponent(() => import('@/views/report/formParam/MBTSN_CQDB.vue'));
const MB13_2_TT342_STC_QN = defineAsyncComponent(() => import('@/views/report/formParam/MB13_2_TT342_STC_QN.vue'));
const MB13_2_TT342_STC_QN_TH = defineAsyncComponent(() => import('@/views/report/formParam/MB13_2_TT342_STC_QN_TH.vue'));
//Mẫu 13.5
const MB13_5_TT342_DVCQ_Report = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_5_TT342_DVCQ_Report.vue'),
);
const MB13_5_TT342_DVCQ_Summary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_5_TT342_DVCQ_Summary.vue'),
);
const MB13_5_TT342_DVCQ_Examine = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_5_TT342_DVCQ_Examine.vue'),
);

const MB14_TT69_Report_HCSN3 = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB14_TT69_Report_HCSN3.vue'),
);

const KH_KPTL73_SummaryEstimate = defineAsyncComponent(() =>
  import('@/views/report/formParam/KH_KPTL73_SummaryEstimate.vue'),
);
const KH_KPTL73_SummaryEstimate_HCSN = defineAsyncComponent(() =>
  import('@/views/report/formParam/KH_KPTL73_SummaryEstimate_HCSN.vue'),
);
const KH_KPTL73_CQSN = defineAsyncComponent(() => import('@/views/report/formParam/KH_KPTL73_CQSN.vue'));
const KH_KPTL73_SubmitEstimate_HCSN = defineAsyncComponent(() =>
  import('@/views/report/formParam/KH_KPTL73_SubmitEstimate_HCSN.vue'),
);
const KH_KPTL73_Report_CQSN = defineAsyncComponent(() => import('@/views/report/formParam/KH_KPTL73_Report_CQSN.vue'));
const KH_KPTL73_SubmitEstimate = defineAsyncComponent(() =>
  import('@/views/report/formParam/KH_KPTL73_SubmitEstimate.vue'),
);
const KH_KPTL73_AuditEstimate = defineAsyncComponent(() =>
  import('@/views/report/formParam/KH_KPTL73_AuditEstimate.vue'),
);

const KH_KPTL73 = defineAsyncComponent(() => import('@/views/report/formParam/KH_KPTL73.vue'));

const MB14_TT69_Summary_DVCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB14_TT69_Summary_DVCQ.vue'),
);

const MB15_TT69_Summary_DVCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB15_TT69_Summary_DVCQ.vue'),
);
const MB13_TT69_Report_HCSN3 = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_TT69_Report_HCSN3.vue'),
);
const MB13_TT69_Summary_HCSN3 = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_TT69_Summary_HCSN3.vue'),
);
const MB14_TT69_Summary_HCSN3 = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB14_TT69_Summary_HCSN3.vue'),
);
const MB32a_STCKH_ViewReport = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB32a_STCKH_ViewReport.vue'),
);
const MB32a_STCKH_ViewEstimate = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB32a_STCKH_ViewEstimate.vue'),
);
// Mẫu biểu 13.5, 13.7, 13.9 - view tổng hợp
const MB13_5_TT342_STC_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_5_TT342_STC_ViewSummary.vue'),
);
const MB15_ND31_STC_TH = defineAsyncComponent(() => import('@/views/report/formParam/MB15_ND31_STC_TH.vue'));
const MB15_ND31_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB15_ND31_STC.vue'));
const MB13_5_TT342_STC_TH = defineAsyncComponent(() => import('@/views/report/formParam/MB13_5_TT342_STC_TH.vue'));
const MB13_8_TT342_STC_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_8_TT342_STC_ViewSummary.vue'),
);
const MB13_9_TT342_STC_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_9_TT342_STC_ViewSummary.vue'),
);
// Mẫu biểu 13.5, 13.7, 13.9 - view báo cáo
const MB13_5_TT342_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_5_TT342_STC_ViewSummary.vue'),
);
const MB13_8_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB13_8_TT342_STC.vue'));
const MB13_9_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB13_9_TT342_STC.vue'));

// Mẫu biểu 05 in ở tổng hợp STC
const MB05_TT342_ViewSummary_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB05_TT342_ViewSummary_STC.vue'),
);
// Mẫu biểu 05 in ở báo cáo STC
const BM2a_GTVTHCM_CQSN = defineAsyncComponent(() => import('@/views/report/formParam/BM2a_GTVTHCM_CQSN.vue'));
const BM2b_GTVTHCM_CQSN = defineAsyncComponent(() => import('@/views/report/formParam/BM2b_GTVTHCM_CQSN.vue'));
const MB05_TT342_ViewReport_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB05_TT342_ViewReport_STC.vue'),
);
// report 07 - STC
const MB07_STC_TT342_ViewReport = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB07_STC_TT342_ViewReport.vue'),
);
const MB12_1_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB12_1_TT342_STC.vue'));
const MB17_TT692017_BTC_TY = defineAsyncComponent(() => import('@/views/report/formParam/MB17_TT692017_BTC_TY.vue'));
const MB17_TT692017_BTC_TYSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB17_TT692017_BTC_TYSummary.vue'),
);
const MB19_TT692017_BTC_TY = defineAsyncComponent(() => import('@/views/report/formParam/MB19_TT692017_BTC_TY.vue'));
const MB19_TT692017_BTC_TYSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB19_TT692017_BTC_TYSummary.vue'),
);

const MB18_TT692017_TT_BTC = defineAsyncComponent(() => import('@/views/report/formParam/MB18_TT692017_TT_BTC.vue'));

const MB12_4_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB12_4_TT342_STC.vue'));

const MB12_2_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB12_2_TT342_STC.vue'));
const MB12_2_TT342_ViewSummary_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_2_TT342_ViewSummary_STC.vue'),
);
const MB14_TT342_STC_ViewSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB14_TT342_STC_ViewSummary.vue'),
);
const MB14_TT342_STC_ViewReport = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB14_TT342_STC_ViewReport.vue'),
);

const MB13_7_AuditSummary_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_7_AuditSummary_STC.vue'),
);
const MB13_7_ViewSummary_AuditSummary_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_7_ViewSummary_AuditSummary_STC.vue'),
);

const MB13_7_ViewSummary_AfterEstimateSummary_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_7_ViewSummary_AfterEstimateSummary_STC.vue'),
);

const MB13_9_ViewSummary_AfterEstimateSummary_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_9_ViewSummary_AfterEstimateSummary_STC.vue'),
);

const MB11_1_TT342_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB11_1_TT342_STC.vue'));
const MB13_8_TT342_STC_ViewBalance = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_8_TT342_STC_ViewBalance.vue'),
);

const MB17_ND31_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB17_ND31_STC.vue'));

const MB10_ND31_2017_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB10_ND31_2017_STC.vue'));
const MB10_ND31_2017_STC_Summary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB10_ND31_2017_STC_Summary.vue'),
);
const MB09_ND31_2017_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB09_ND31_2017_STC.vue'));
const MB09_ND31_2017_STC_Summary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB09_ND31_2017_STC_Summary.vue'),
);

const MB07_ViewSummary_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB07_ViewSummary_STC.vue'));

const MB08_ViewSummary_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB08_ViewSummary_STC.vue'));

const MB16_ND31_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB16_ND31_STC.vue'));
const MB16_ND31_STC_TH = defineAsyncComponent(() => import('@/views/report/formParam/MB16_ND31_STC_TH.vue'));

const MB14_TT342_STC_ViewEstimate = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB14_TT342_STC_ViewEstimate.vue'),
);
const MB02_PTC_VanBan = defineAsyncComponent(() => import('@/views/report/formParam/MB02_PTC_VanBan.vue'));

const MB02_TY_ViewSummary_TT69 = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB02_TY_ViewSummary_TT69.vue'),
);

const MB03_TY_ViewSummary_TT69 = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB03_TY_ViewSummary_TT69.vue'),
);

// In Biểu 13.7: Cơ sở tính chi sự nghiệp bảo vệ môi trường Nguồn dữ liệu Sau Kiểm tra
const MB13_7_ViewExam_DVCQ = defineAsyncComponent(() => import('@/views/report/formParam/MB13_7_ViewExam_DVCQ.vue'));
// In Biểu 13.7: Cơ sở tính chi sự nghiệp bảo vệ môi trường Nguồn dữ liệu Lập Dự toán
const MB13_7_ViewSummary_DVCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_7_ViewSummary_DVCQ.vue'),
);
// In Biểu 13.7: Cơ sở tính chi sự nghiệp bảo vệ môi trường Nguồn dữ liệu Nộp Dự toán
const MB13_7_ViewReport_DVCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB13_7_ViewReport_DVCQ.vue'),
);

const MB14_ND31_PTC_TH = defineAsyncComponent(() => import('@/views/report/formParam/MB14_ND31_PTC_TH.vue'));

const MB11_1_TT342_ViewAudit_DVCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB11_1_TT342_ViewAudit_DVCQ.vue'),
);

const MB17_TT342_ViewSubmit_PTC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB17_TT342_ViewSubmit_PTC.vue'),
);

const MB12_2_TT342_CQSN_ViewReport = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_2_TT342_CQSN_ViewReport.vue'),
);

const MB12_2_TT342_CQSN_ViewReport_KH = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_2_TT342_CQSN_ViewReport_KH.vue'),
);

const MB12_3_ViewReport_HCSNCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_3_ViewReport_HCSNCQ.vue'),
);

const MB12_4_ViewReport_HCSNCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_4_ViewReport_HCSNCQ.vue'),
);

const MB12_5_ViewReport_HCSNCQ = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB12_5_ViewReport_HCSNCQ.vue'),
);

const PGDCT_01_THDT = defineAsyncComponent(() => import('@/views/report/formParam/PGDCT_01_THDT.vue'));

const MB32_PTCKH_TT342 = defineAsyncComponent(() => import('@/views/report/formParam/MB32_PTCKH_TT342.vue'));

const MB32_PTCKH_TT342Popup = defineAsyncComponent(() =>
  import('@/views/report/popupcustom/MB32_PTCKH_TT342Popup.vue'),
);

const MB37_STCKhanhHoaHCSN = defineAsyncComponent(() => import('@/views/report/formParam/MB37_STCKhanhHoaHCSN.vue'));

const MB15_1_TML_Summary = defineAsyncComponent(() => import('@/views/report/formParam/MB15_1_TML_Summary.vue'));

const MB15_1_TML_Submit = defineAsyncComponent(() => import('@/views/report/formParam/MB15_1_TML_Submit.vue'));

const SubmitEstimateArrgrateViewReportDVXModeExpense = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/tabs/popup/SubmitEstimateArrgrateViewReportDVXModeExpense.vue'
  ),
);
const MB_NSH02_PTC = defineAsyncComponent(() => import('@/views/report/formParam/MB_NSH02_PTC.vue'));
const MB_NSH02_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB_NSH02_STC.vue'));
const BM_DTKT_STC = defineAsyncComponent(() => import('@/views/report/formParam/BM_DTKT_STC.vue'));
const BM_DTKH_STC = defineAsyncComponent(() => import('@/views/report/formParam/BM_DTKH_STC.vue'));
const MB_NST01_STC = defineAsyncComponent(() => import('@/views/report/formParam/MB_NST01_STC.vue'));
const MB_NST01_SN = defineAsyncComponent(() => import('@/views/report/formParam/MB_NST01_SN.vue'));
const MB_ReportTemplateFile = defineAsyncComponent(() => import('@/views/report/formParam/MB_ReportTemplateFile.vue'));
const BM_DTTT_STC = defineAsyncComponent(() => import('@/views/report/formParam/BM_DTTT_STC.vue'));

const MB15_1_TML_Report = defineAsyncComponent(() => import('@/views/report/formParam/MB15_1_TML_Report.vue'));

const MB18_LoanRepayment_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB18_LoanRepayment_STC.vue'),
);
const MB37_STCKhanhHoa = defineAsyncComponent(() => import('@/views/report/formParam/MB37_STCKhanhHoa.vue'));

const RequestDetailHCSNReportInitial = defineAsyncComponent(() =>
  import('@/views/examine/tabInitial/RequestDetailHCSNReportInitial.vue'),
);

const MB30_LoanRepayment_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB30_LoanRepayment_STC.vue'),
);

const MB15_1_TML_Audit_Report = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB15_1_TML_Audit_Report.vue'),
);

const MBNTNNKH_CQDB = defineAsyncComponent(() =>
  import('@/views/report/formParam/MBNTNNKH_CQDB.vue'),
);

const MBDTL_CQDB = defineAsyncComponent(() =>
  import('@/views/report/formParam/MBDTL_CQDB.vue'),
);

const MBNBLKH_CQDB = defineAsyncComponent(() =>
  import('@/views/report/formParam/MBNBLKH_CQDB.vue'),
);

const MBNBLHH_CQDB = defineAsyncComponent(() =>
  import('@/views/report/formParam/MBNBLHH_CQDB.vue'),
);

const MBNTNNHH_CQDB = defineAsyncComponent(() =>
  import('@/views/report/formParam/MBNTNNHH_CQDB.vue'),
);

const MB05_LoanRepayment_TY_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB05_LoanRepayment_TY_STC.vue'),
);

const MB15_1_TML_AuditSummary = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB15_1_TML_AuditSummary.vue'),
);
const MB15_1_TML_SummaryArrgrate = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB15_1_TML_SummaryArrgrate.vue'),
);
const MB15_1_TML_SubmitArrgrate = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB15_1_TML_SubmitArrgrate.vue'),
);
const MB15_1_TML_AuditReceive_STC = defineAsyncComponent(() =>
  import('@/views/report/formParam/MB15_1_TML_AuditReceive_STC.vue'),
);
const ExplanSalary_KH_KPTL73_STC_Audit_Dvcq = defineAsyncComponent(() =>
  import('@/views/report/formParam/ExplanSalary_KH_KPTL73_STC_Audit_Dvcq.vue'),
);

const ExplanSalary_KH_KPTL73_STC_Audit_Hcsn = defineAsyncComponent(() =>
  import('@/views/report/formParam/ExplanSalary_KH_KPTL73_STC_Audit_Hcsn.vue'),
);
const MB12_5_KH_TT342_HCSN = defineAsyncComponent(() => import('@/views/report/formParam/MB12_5_KH_TT342_HCSN.vue'));
const MB12_5_KH_TT342_DVCQ = defineAsyncComponent(() => import('@/views/report/formParam/MB12_5_KH_TT342_DVCQ.vue'));
const MB13_12_KH_Report = defineAsyncComponent(() => import('@/views/report/formParam/MB13_12_KH_Report.vue'));


const MB13_10_KH_HCSN = defineAsyncComponent(() => import('@/views/report/formParam/MB13_10_KH_HCSN.vue'));

const MB13_10_KH_DVCQ = defineAsyncComponent(() => import('@/views/report/formParam/MB13_10_KH_DVCQ.vue'));

export function registerReport(app) {
  app.component('BaseReportParamDefault', BaseReportParamDefault);
  app.component('MB17_TT342_ViewSubmit_PTC', MB17_TT342_ViewSubmit_PTC);
  app.component('MB16_test_base_new', MB16_test_base_new);
  app.component('MB12_2_TT342_CQSN_ViewReport', MB12_2_TT342_CQSN_ViewReport);
  app.component('MB12_2_TT342_CQSN_ViewReport_KH', MB12_2_TT342_CQSN_ViewReport_KH);
  app.component('MB12_3_ViewReport_HCSNCQ', MB12_3_ViewReport_HCSNCQ);
  app.component('MB12_4_ViewReport_HCSNCQ', MB12_4_ViewReport_HCSNCQ);
  app.component('MB12_5_ViewReport_HCSNCQ', MB12_5_ViewReport_HCSNCQ);
  app.component('MB04_HDXNK_ViewReport_PTCHT', MB04_HDXNK_ViewReport_PTCHT);
  app.component('MB04_HDXNK_ViewSummary_PTCHT', MB04_HDXNK_ViewSummary_PTCHT);
  app.component('MB29_1_ViewEstimate_PTCHT', MB29_1_ViewEstimate_PTCHT);
  app.component('MB29_2_ViewEstimate_PTCHT', MB29_2_ViewEstimate_PTCHT);
  app.component('BaseReportPopupShowHide', BaseReportPopupShowHide);
  app.component('BaseReportPreviewPrint', BaseReportPreviewPrint);
  app.component('SummaryEstimateArrgrateViewReportCQSNModeDetail', SummaryEstimateArrgrateViewReportCQSNModeDetail);
  app.component('SummaryEstimateArrgrateViewReportCQSNModeSummary', SummaryEstimateArrgrateViewReportCQSNModeSummary);
  app.component('SummaryEstimateArrgrateViewReportSTCModeRevenue', SummaryEstimateArrgrateViewReportSTCModeRevenue);
  app.component('SummaryEstimateArrgrateViewReportSTCModeExpense', SummaryEstimateArrgrateViewReportSTCModeExpense);
  app.component('SummaryEstimateArrgrateViewReportSTCModeBalance', SummaryEstimateArrgrateViewReportSTCModeBalance);
  app.component('SummaryEstimateArrgrateViewReportPTCModeRevenue', SummaryEstimateArrgrateViewReportPTCModeRevenue);
  app.component('SummaryEstimateArrgrateViewReportPTCModeExpense', SummaryEstimateArrgrateViewReportPTCModeExpense);
  app.component('SummaryEstimateArrgrateViewReportPTCModeBalance', SummaryEstimateArrgrateViewReportPTCModeBalance);
  app.component('SummaryEstimateArrgrateViewReportPTCModeSummary', SummaryEstimateArrgrateViewReportPTCModeSummary);
  app.component('SummaryEstimateArrgrateViewReportPTCModeDetail', SummaryEstimateArrgrateViewReportPTCModeDetail);
  app.component('SummaryEstimateArrgrateSectorWideViewReport', SummaryEstimateArrgrateSectorWideViewReport);
  app.component('SubmitEstimateArrgrateSectorWideViewReport', SubmitEstimateArrgrateSectorWideViewReport);
  app.component('TotalEstimateHCSNReportModeSummary', TotalEstimateHCSNReportModeSummary);
  app.component('RequestDetailHCSNReport', RequestDetailHCSNReport);
  app.component('RequestDetailSCQReport', RequestDetailSCQReport);
  app.component('TotalEstimateHCSNReportModeDetail', TotalEstimateHCSNReportModeDetail);
  app.component('MB01_TT344', MB01_TT344);
  app.component('MB01_TT344_ViewSummary', MB01_TT344_ViewSummary);
  app.component('MB12_1_TT342', MB12_1_TT342);
  app.component('MB12_1_TT342_QN', MB12_1_TT342_QN);
  app.component('MB01_PTCBV', MB01_PTCBV);
  app.component('MB01_PTC_VanBan', MB01_PTC_VanBan);
  app.component('MB31a_STCKH', MB31a_STCKH);
  app.component('MB13_1_ViewSummary_Check', MB13_1_ViewSummary_Check);
  app.component('MB12_1_TT342_PTC', MB12_1_TT342_PTC);
  app.component('MB12_2_TT342_PTC', MB12_2_TT342_PTC);
  app.component('MB12_1_TT342_ViewSummary_HCSN', MB12_1_TT342_ViewSummary_HCSN);
  app.component('MB12_1_TT342_ViewSummary_HCSN_QN', MB12_1_TT342_ViewSummary_HCSN_QN);
  app.component('MB12_2_TT342_ViewSummary_HCSN', MB12_2_TT342_ViewSummary_HCSN);
  app.component('MB12_1_TT342_KH', MB12_1_TT342_KH);
  app.component('MB12_1_TT342_KH_DVCQ', MB12_1_TT342_KH_DVCQ);
  app.component('MB12_2_TT342_CQSN', MB12_2_TT342_CQSN);
  app.component('MB12_1_CQSN', MB12_1_CQSN);
  app.component('MB12_3_TT342_PTC', MB12_3_TT342_PTC);
  app.component('MB12_4_TT342_PTC', MB12_4_TT342_PTC);
  app.component('MB12_5_TT342_PTC', MB12_5_TT342_PTC);
  app.component('MB12_5_TT342_STC', MB12_5_TT342_STC);
  app.component('MB12_1_TT342_ViewSummary_CQSN', MB12_1_TT342_ViewSummary_CQSN);
  app.component('MB12_1_TT342_ViewExamine_CQSN', MB12_1_TT342_ViewExamine_CQSN);
  app.component('SummaryEstimateArrgrateViewReportDVXModeRevenue', SummaryEstimateArrgrateViewReportDVXModeRevenue);
  app.component('SummaryEstimateArrgrateViewReportDVXModeExpense', SummaryEstimateArrgrateViewReportDVXModeExpense);
  app.component('SummaryEstimateArrgrateViewReportDVXModeBalance', SummaryEstimateArrgrateViewReportDVXModeBalance);
  app.component('MB13_1_PTC', MB13_1_TT342_PTC);
  app.component('MB13_1_TC', MB13_1_TC);
  app.component('MB12_2_TT342', MB12_2_TT342);
  app.component('MB12_2_TT342_HCSN_KH', MB12_2_TT342_HCSN_KH);
  app.component('MB12_2_TT342_ViewKH_HCSN', MB12_2_TT342_ViewKH_HCSN);
  app.component('MB02_TT344', MB02_TT344);
  app.component('MB02_TT344_ViewSummary', MB02_TT344_ViewSummary);
  app.component('MB03_TT344', MB03_TT344);
  app.component('MB03_TT344_ViewSummary', MB03_TT344_ViewSummary);
  app.component('MB15_2_TML', MB15_2_TML);
  app.component('MB05_TT342', MB05_TT342);
  app.component('MB05_TT342_KH', MB05_TT342_KH);
  app.component('MB07_TT342', MB07_TT342);
  app.component('MB07_KH_TT342', MB07_KH_TT342);
  app.component('MB07_STC_TT342_ViewReport', MB07_STC_TT342_ViewReport);
  app.component('MB07_STC_TT342_ViewSummary', MB07_STC_TT342_ViewReport);
  app.component('MB31_TT342_ViewSummary_PTC', MB31_TT342_ViewSummary_PTC);
  app.component('MB31_TT342_ViewSummary_STC', MB31_TT342_ViewSummary_STC); // biểu 31 STC : in ở tổng hợp sau lập
  app.component('MB31_TT342_ViewReport_STC', MB31_TT342_ViewReport_STC); // biểu 31 STC : in ở báo cáo
  app.component('MB16_PTC_Estimte_by_field', MB16_PTC_Estimte_by_field); // biểu 16 PTC: Dự toán theo lĩnh vực
  app.component('MB16_PTC_Estimte_by_field_BC', MB16_PTC_Estimte_by_field_BC); // biểu 16 PTC: IN tại màn hình báo cáo
  app.component('MB01_PTCBV_ViewSummary_PTC', MB01_PTCBV_ViewSummary_PTC);
  app.component('B06_ViewSummary_PTC', B06_ViewSummary_PTC);
  app.component('MB29_2_TT342_ViewSummary_PTC', MB29_2_TT342_ViewSummary_PTC);
  app.component('MB08ReportPopupShowPercent', MB08ReportPopupShowPercent);
  app.component('MB291ReportPopupShowEstimate', MB291ReportPopupShowEstimate);
  app.component('MB11_ND31_STCReportPopup', MB11_ND31_STCReportPopup);
  app.component('MB32a_STCKHReportPopup', MB32a_STCKHReportPopup);
  app.component('MB32_TT342', MB32_TT342);
  app.component('MB32_TT342_ViewSummary_STC', MB32_TT342_ViewSummary_STC);
  app.component('MB32_TT342_ViewReport_STC', MB32_TT342_ViewReport_STC);
  app.component('MB32_TT342_ViewReport_STC_KH', MB32_TT342_ViewReport_STC_KH);
  app.component('MB32_TT342_ViewSummary_STC_KH', MB32_TT342_ViewSummary_STC_KH);
  app.component('MB32_TT342_STC_KH_Popup', MB32_TT342_STC_KH_Popup);
  app.component('MB12_ND31_ViewSummary_PTC', MB12_ND31_ViewSummary_PTC);
  app.component('MB12_ND31_PTC', MB12_ND31_PTC);
  app.component('MB32_TT342_BC', MB32_TT342_BC);
  app.component('MB06_PTC', MB06_PTC);
  app.component('MB06_HCSNCQ', MB06_HCSNCQ);
  app.component('MB06_TT342_KH_HCSNCQ', MB06_TT342_KH_HCSNCQ);
  app.component('MB06_HCSNCQ_TH', MB06_HCSNCQ_TH);
  app.component('MB06_HCSNCQ_KT', MB06_HCSNCQ_KT);
  app.component('MB06_TT342_STC', MB06_TT342_STC);
  app.component('ReportKH_KPTL73_STC_SUMMARY', ReportKH_KPTL73_STC_SUMMARY);
  app.component('MB17_TT342_ViewSummary_PTC', MB17_TT342_ViewSummary_PTC);
  app.component('MB17_ND31_ViewReport_PTC', MB17_ND31_ViewReport_PTC);
  app.component('MB13_2_TT342', MB13_2_TT342);
  app.component('MB13_2_QN_TT342', MB13_2_QN_TT342);
  app.component('MB13_9_TT342_HCSN3', MB13_9_TT342_HCSN3);
  app.component('MB14_TT342_Audit_PTC', MB14_TT342_Audit_PTC);
  app.component('MBCTMTQG_PTCHT', MBCTMTQG_PTCHT);
  app.component('MB14_CSTDT', MB14_CSTDT);
  app.component('MB14_CSTDT_BC', MB14_CSTDT_BC);
  app.component('MB11_1_DTC_TH', MB11_1_DTC_TH);
  app.component('MB13_10_TT342_ViewSummary_HCSN', MB13_10_TT342_ViewSummary_HCSN);
  app.component('MB08_Other_Summary_PTCHT', MB08_Other_Summary_PTCHT);
  app.component('MB08_Other_PTCHT', MB08_Other_PTCHT);
  app.component('MB13_7_TT342_HCSN3', MB13_7_TT342_HCSN3);
  app.component('MB13_7_TT342_Summary_HCSN3', MB13_7_TT342_Summary_HCSN3);
  app.component('MB13_8_TT342_HCSN3', MB13_8_TT342_HCSN3);
  app.component('MB13_8_TT342_Summary_HCSN3', MB13_8_TT342_Summary_HCSN3);
  app.component('MB13_9_TT342_Summary_PTC', MB13_9_TT342_Summary_PTC);
  app.component('MB13_9_TT342_Summary_CQ', MB13_9_TT342_Summary_CQ);
  app.component('MB13_9_TT342_Report_CQ', MB13_9_TT342_Report_CQ);
  app.component('MB13_9_TT342_Audit_CQ', MB13_9_TT342_Audit_CQ);
  app.component('MB13_9_TT342_Audit_District_Summary_PTC', MB13_9_TT342_Audit_District_Summary_PTC);
  app.component('MBThuSN_Other_HCSN3_HamTan', MBThuSN_Other_HCSN3_HamTan);
  app.component('MBThuSN_Summary_Other_HCSN3_HamTan', MBThuSN_Summary_Other_HCSN3_HamTan);
  app.component('MB04_ViewSymmetrical_PTC', MB04_ViewSymmetrical_PTC);
  app.component('MB23_ViewSummary_TT342', MB23_ViewSummary_TT342);
  app.component('MB12_3_TT342', MB12_3_TT342);
  app.component('MB12_3_TT342_Report_HCSN3_KH', MB12_3_TT342_Report_HCSN3_KH);
  app.component('MB12_3_TT342_Summary_HCSN3_KH', MB12_3_TT342_Summary_HCSN3_KH);
  app.component('MB12_3_TT342_ViewReport_HCSNCQ_KH', MB12_3_TT342_ViewReport_HCSNCQ_KH);
  app.component('MB12_3_TT342_ViewSummary_HCSNCQ_KH', MB12_3_TT342_ViewSummary_HCSNCQ_KH);
  app.component('MB12_3_TT342_AuditSummary_HCSNCQ_KH', MB12_3_TT342_AuditSummary_HCSNCQ_KH);
  app.component('MB12_3_TT342_ViewSummary_HCSNC3', MB12_3_TT342_ViewSummary_HCSNC3);
  app.component('MB12_4_TT342', MB12_4_TT342);
  app.component('MB12_4_TT342_ViewSummary_HCSNC3', MB12_4_TT342_ViewSummary_HCSNC3);
  app.component('MB12_4_KH_TT342_Summary_HCSNC3', MB12_4_KH_TT342_Summary_HCSNC3);
  app.component('MB12_4_KH_ViewReport_HCSNCQ', MB12_4_KH_ViewReport_HCSNCQ);
  app.component('MB12_4_KH_TT342_DVCQ', MB12_4_KH_TT342_DVCQ);
  app.component('MB12_4_KH_ViewSummary_HCSNCQ', MB12_4_KH_ViewSummary_HCSNCQ);
  app.component('MB12_4_TT342_KH', MB12_4_TT342_KH);
  app.component('MB12_5_TT342', MB12_5_TT342);
  app.component('MB12_5_TT342_ViewSummary_HCSNC3', MB12_5_TT342_ViewSummary_HCSNC3);
  app.component('MB13_2_Report_TT342', MB13_2_Report_TT342);
  app.component('MB13_2_QN_Report_TT342', MB13_2_QN_Report_TT342);
  app.component('MB35_Report_TT342', MB35_Report_TT342);
  app.component('MB13_9_TT342_Summary_HCSN3', MB13_9_TT342_Summary_HCSN3);
  app.component('MB14_TT342', MB14_TT342);
  app.component('MB08_TT342_ViewSummary_XHT', MB08_TT342_ViewSummary_XHT);
  app.component('PTCHT_MB09', MB09_PTCHT); // biểu 09 PTC Ham tan
  app.component('PTCHT_MB07', MB07_PTCHT); // biểu 07 PTC Ham tan
  app.component('MBS13_5_TT342', MBS13_5_TT342);
  app.component('MB05_HamTan', MB05_HamTan);
  app.component('MB05_TT342_ViewSummary', MB05_TT342_ViewSummary);
  app.component('MB07_TT342_ViewSummary', MB07_TT342_ViewSummary);
  app.component('MB07_KH_TT342_ViewSummary', MB07_KH_TT342_ViewSummary);
  app.component('B11_1_TT342_HCSN', B11_1_TT342_HCSN);
  app.component('MB13_10_TT342_ViewReport_HCSN', B13_10_TT342_ViewReport_HCSN);
  app.component('MB08_TT342_ViewReport_XHT', MB08_TT342_ViewReport_XHT);
  app.component('MB01_PTC', MB01_PTC);
  app.component('MB_TH_CTMTQG_PTCHT', MB_TH_CTMTQG_PTCHT);
  app.component('MB13_9_TT342_Report_PTC', MB13_9_TT342_Report_PTC);
  app.component('MB15_ND31_ViewReport_PTC', MB15_ND31_ViewReport_PTC);
  app.component('MB15_ND31_ViewSummary_PTC', MB15_ND31_ViewSummary_PTC);
  app.component('MB02_TT342_ViewSummary', MB02_TT342_ViewSummary);
  app.component('MB07_STC', MB07_STC);
  app.component('MB08_STC', MB08_STC);
  app.component('MLHT_HG_HCSNC3', MLHT_HG_HCSNC3);
  // MB13_5_TT342_ViewSummary_PTC
  // Biểu 13.5 (Phòng tài chính)
  app.component('MB13_5_TT342_ViewSummary_PTC', MB13_5_TT342_ViewSummary_PTC); // View cân đối
  app.component('MB13_5_TT342_ViewReport_PTC', MB13_5_TT342_ViewSummary_PTC); // View báo cáo
  app.component('MB13_5_TT342_ViewChecking_PTC', MB13_5_TT342_ViewSummary_PTC); // View tổng hợp (sau kiểm tra)
  app.component('MB13_ND31_PTC', MB13_ND31_PTC); // Biểu 13 NĐ31 PTC
  app.component('MB13_ND31_ViewSummary_PTC', MB13_ND31_ViewSummary_PTC); // Biểu 13 NĐ31 PTC view tổng hợp sau lập
  app.component('MB13_ND31_STC', MB13_ND31_STC); // Biểu 13 NĐ31 STC
  app.component('MB13_ND31_ViewSummary_STC', MB13_ND31_ViewSummary_STC); // Biểu 13 NĐ31 STC view tổng hợp sau lập
  // Biểu 11.1 (Phòng tài chính)
  app.component('MB11_1_TT342_ViewSummary_PTC', MB13_5_TT342_ViewSummary_PTC); // view Cân đối
  app.component('MB11_1_TT342_ViewReport_PTC', MB13_5_TT342_ViewSummary_PTC); // view Báo cáo
  app.component('MB11_1_TT342_ViewChecking_PTC', MB13_5_TT342_ViewSummary_PTC); // View tổng hợp (sau kiểm tra)

  app.component('MB04_TT69_STC', MB04_TT69_STC);
  app.component('MB04_TT69_ViewSummary_STC', MB04_TT69_ViewSummary_STC);
  app.component('MB01_PTC_SUMMARY', MB01_PTC);
  app.component('MB14_TT342SUMMARY', MB14_TT342);
  app.component('MBS13_5_TT342_VIEWSUMMARY', MBS13_5_TT342);
  app.component('ViewSummary_Balance_MB13_8_TT342_HCSN_PTC', ViewSummary_Balance_MB13_8_TT342_HCSN_PTC); // Biểu 13.8 TT342 PTC - Tổng hợp cân đối
  app.component('MBS26_TT342', MBS26_TT342);
  app.component('MBS26_TT342_VIEWSUMMARY', MBS26_TT342);
  app.component('MB31_TT342_ViewReport_PTC', MB31_TT342_ViewReport_PTC);
  app.component('ViewSummary_Checking_MB13_8_TT342_HCSN_PTC', ViewSummary_Checking_MB13_8_TT342_HCSN_PTC); // Biểu 13.8 TT342 PTC - Tổng hợp kiểm tra
  app.component('MB14_TT342_HCSN_TH', MB14_TT342_HCSN_TH);
  app.component('MB01_NT_HCSN3', MB01_NT_HCSN3);
  app.component('MB01_NT_HCSN3_SummaryEstimate', MB01_NT_HCSN3_SummaryEstimate);
  app.component('MB01_NT_CQSN', MB01_NT_CQSN);
  app.component('MB01_NT_CQSN_SummaryEstimate', MB01_NT_CQSN_SummaryEstimate);
  app.component('MB01_NT_CQSN_AuditEstimate', MB01_NT_CQSN_AuditEstimate);
  app.component('AllocationPublishingReportSCQ', AllocationPublishingReportSCQ);
  app.component('MB14_TT342_HCSN_BC', MB14_TT342_HCSN_BC);
  app.component('MB17_TY_HCSN3', MB17_TY_HCSN3);
  app.component('MB18_TY_HCSN3', MB18_TY_HCSN3);
  app.component('MB17_TY_HCSN3_ViewSummary', MB17_TY_HCSN3_ViewSummary);
  app.component('MB18_TY_HCSN3_ViewSummary', MB18_TY_HCSN3_ViewSummary);
  app.component('MB13_1_HCSNC3', MB13_1_HCSNC3);
  app.component('MB13_1_HCSNC3QN', MB13_1_HCSNC3QN);
  app.component('MB13_1_HCSNC3_ViewSummary', MB13_1_HCSNC3_ViewSummary);
  app.component('MB29_2_TT342_PTC', MB29_2_TT342_PTC);
  app.component('MB29_1_TT342_PTC', MB29_1_TT342_PTC);
  app.component('MB29_2_TT342_STC', MB29_2_TT342_STC);
  app.component('MB29_2_TT342_ViewSummary_STC', MB29_2_TT342_ViewSummary_STC);
  app.component('MB05_TT342_ViewSummary_PTC', MB05_TT342_ViewSummary_PTC);
  app.component('MB14_ND31_PTC', MB14_ND31_PTC);
  app.component('ViewSummary_Report_MB13_8_TT342_HCSN_PTC', ViewSummary_Report_MB13_8_TT342_HCSN_PTC); // Biểu 13.8 TT342 PTC - In ở báo cáo
  app.component('MB02_TT342', MB02_TT342_ViewSummary);
  app.component('MB13_7_ViewExam_XHT', MB13_7_ViewExam_XHT);
  app.component('MB13_7_ViewSummary_XHT', MB13_7_ViewSummary_XHT);
  app.component('MB27_TT342_ViewSummary_PTC', MB27_TT342_ViewSummary_PTC);
  app.component('MB27_TT342_ViewReport_PTC', MB27_TT342_ViewReport_PTC);
  app.component('MB13_7_ViewReport_XHT', MB13_7_ViewReport_XHT);
  app.component('MB07_TT342_ViewSummary_PTC', MB07_TT342_ViewSummary_PTC);
  app.component('MB13_2_ViewSummary_Check_PTC', MB13_2_ViewSummary_Check_PTC);
  app.component('MB13_2_ViewSummary_Create_PTC', MB13_2_ViewSummary_Create_PTC);
  app.component('MB13_2_ViewReport_PTC', MB13_2_ViewReport_PTC); // Biểu 13.2 TT342 PTC - Xem báo cáo
  app.component('MB05_TT342_HCSNCQ', MB05_TT342_HCSNCQ);
  app.component('MB05_TT342_KH_HCSNCQ', MB05_TT342_KH_HCSNCQ);
  app.component('NLTX_HG_HCSN', NLTX_HG_HCSN);
  app.component('CCTL_HG_LDT_HCSN', CCTL_HG_LDT_HCSN);
  app.component('ViewSummary_Report_MB13_8_TT342_HCSN_CQ', ViewSummary_Report_MB13_8_TT342_HCSN_CQ); // Biểu 13.8 TT342 PTC - In ở báo cáo
  app.component('ViewSummary_MB13_8_TT342_HCSN_CQ', ViewSummary_MB13_8_TT342_HCSN_CQ);
  app.component('MB14_TT342_ViewSummary', MB14_TT342_ViewSummary);
  app.component('MB05_TT342_ViewSummary_HCSNCQ', MB05_TT342_ViewSummary_HCSNCQ);
  app.component('MB05_TT342_ViewSummaryAudit_HCSNCQ', MB05_TT342_ViewSummaryAudit_HCSNCQ);
  app.component('MB13_1_ViewSummary_CQ', MB13_1_ViewSummary_CQ);
  app.component('MB13_1_ViewReport_CQ', MB13_1_ViewReport_CQ);
  app.component('MB13_1_ViewReport_CQ_QN', MB13_1_ViewReport_CQ_QN);
  app.component('MB13_11_KH_CQ', MB13_11_KH_CQ);
  app.component('MB11_1_TT342_ViewSummary_DVCQ', MB11_1_TT342_ViewSummary_DVCQ);
  app.component('MB11_1_TT342_ViewReport_DVCQ', MB11_1_TT342_ViewReport_DVCQ);
  app.component('MB07_TT342_HCSNCQ', MB07_TT342_HCSNCQ);
  app.component('MB07_KH_TT342_HCSNCQ', MB07_KH_TT342_HCSNCQ);
  app.component('MB07_TT342_HCSNCQ_ViewSummary', MB07_TT342_HCSNCQ_ViewSummary);
  app.component('MB07_KH_TT342_HCSNCQ_ViewSummary', MB07_KH_TT342_HCSNCQ_ViewSummary);
  app.component('MB07_TT342_HCSNCQ_ViewExamine', MB07_TT342_HCSNCQ_ViewExamine);
  app.component('MB07_KH_TT342_HCSNCQ_ViewExamine', MB07_KH_TT342_HCSNCQ_ViewExamine);
  app.component('MB14_TT342_ViewReport', MB14_TT342_ViewReport);
  app.component('MB12_3_ViewSummary_HCSNCQ', MB12_3_ViewSummary_HCSNCQ);
  app.component('MB12_3_TT342_STC', MB12_3_TT342_STC);
  app.component('MB12_4_ViewSummary_HCSNCQ', MB12_4_ViewSummary_HCSNCQ);
  app.component('MB12_5_ViewSummary_HCSNCQ', MB12_5_ViewSummary_HCSNCQ);

  // Giai đoạn 3 năm - thông tư 69 menu báo cáo
  app.component('MB15_TY_HCSNC3', MB15_TY_HCSNC3);
  app.component('MB16_TY_HCSNC3', MB16_TY_HCSNC3);
  app.component('MB19_TY_HCSNC3', MB19_TY_HCSNC3);
  // Giai đoạn 3 năm - thông tư 69 view tổng hợp
  app.component('MB15_TY_HCSNC3_ViewSummary', MB15_TY_HCSNC3_ViewSummary);
  app.component('MB16_TY_HCSNC3_ViewSummary', MB16_TY_HCSNC3_ViewSummary);
  app.component('MB19_TY_HCSNC3_ViewSummary', MB19_TY_HCSNC3_ViewSummary);

  app.component('MB15_1_DVCQ', MB15_1_DVCQ);
  app.component('MB15_2_DVCQ', MB15_2_DVCQ);
  app.component('MB15_2_DVCQ_ViewSummary', MB15_2_DVCQ_ViewSummary);
  app.component('MB15_2_DVCQ_ViewAudit', MB15_2_DVCQ_ViewAudit);
  app.component('MB14_TT342_ViewAudit', MB14_TT342_ViewAudit);
  app.component('MB15_2_HCSN', MB15_2_HCSN);
  app.component('MB15_2_HCSN_ViewSummary', MB15_2_HCSN_ViewSummary);
  app.component('MB13_2_TT342_DVCQ', MB13_2_TT342_DVCQ);
  app.component('MB13_2_TT342_DVCQ_QN', MB13_2_TT342_DVCQ_QN);
  app.component('MB13_2_TT342_DVCQ_ViewAudit', MB13_2_TT342_DVCQ_ViewAudit);
  app.component('MB13_2_TT342_DVCQ_ViewAudit_QN', MB13_2_TT342_DVCQ_ViewAudit_QN);
  app.component('MB13_2_TT342_DVCQ_ViewSummary', MB13_2_TT342_DVCQ_ViewSummary);
  app.component('MB15_1_TT342_STC', MB15_1_TT342_STC);
  app.component('MB15_1_TT342_STC_TH', MB15_1_TT342_STC_TH);
  app.component('MB15_2_TT342_STC', MB15_2_TT342_STC);
  app.component('MB13_2_TT342_STC', MB13_2_TT342_STC);
  app.component('MB13_2_TT342_STC_TH', MB13_2_TT342_STC_TH);
  app.component('MB13_2_TT342_STC_Summary_Audit', MB13_2_TT342_STC_Summary_Audit);
  app.component('MB13_2_TT342_STC_QN_Summary_Audit', MB13_2_TT342_STC_QN_Summary_Audit);
  app.component('MBTSN_CQDB', MBTSN_CQDB);
  app.component('MB13_2_TT342_STC_QN', MB13_2_TT342_STC_QN);
  app.component('MB13_2_TT342_STC_QN_TH', MB13_2_TT342_STC_QN_TH);
  app.component('MB14_TT69_Report_HCSN3', MB14_TT69_Report_HCSN3);
  app.component('KH_KPTL73_SummaryEstimate', KH_KPTL73_SummaryEstimate);
  app.component('KH_KPTL73_SummaryEstimate_HCSN', KH_KPTL73_SummaryEstimate_HCSN);
  app.component('KH_KPTL73', KH_KPTL73);
  app.component('KH_KPTL73_CQSN', KH_KPTL73_CQSN);
  app.component('KH_KPTL73_Report_CQSN', KH_KPTL73_Report_CQSN);
  app.component('KH_KPTL73_SubmitEstimate_HCSN', KH_KPTL73_SubmitEstimate_HCSN);
  app.component('KH_KPTL73_SubmitEstimate', KH_KPTL73_SubmitEstimate);
  app.component('KH_KPTL73_AuditEstimate', KH_KPTL73_AuditEstimate);
  app.component('MB13_TT69_Report_HCSN3', MB13_TT69_Report_HCSN3);
  // Mẫu biểu 05 in ở tổng hợp stc
  app.component('MB05_TT342_ViewSummary_STC', MB05_TT342_ViewSummary_STC);
  // Mẫu biểu 05 in ở báo cáo STC
  app.component('BM2a_GTVTHCM_CQSN', BM2a_GTVTHCM_CQSN);
  app.component('BM2b_GTVTHCM_CQSN', BM2b_GTVTHCM_CQSN);
  app.component('MB05_TT342_ViewReport_STC', MB05_TT342_ViewReport_STC);
  app.component('MB13_TT69_Summary_HCSN3', MB13_TT69_Summary_HCSN3);
  app.component('MB14_TT69_Summary_HCSN3', MB14_TT69_Summary_HCSN3);
  app.component('MB12_1_TT342_STC', MB12_1_TT342_STC);
  app.component('SummaryEstimateArrgrateViewReportSTCModeDetail', SummaryEstimateArrgrateViewReportSTCModeDetail);
  app.component('SummaryEstimateArrgrateViewReportSTCModeSummary', SummaryEstimateArrgrateViewReportSTCModeSummary);
  app.component('SummaryEstimateDistrictViewReportSTCModeSummary', SummaryEstimateDistrictViewReportSTCModeSummary);
  app.component('SummaryEstInitialExplanationDetailPopup', SummaryEstInitialExplanationDetailPopup); 
  app.component('MB17_TT692017_BTC_TY', MB17_TT692017_BTC_TY);
  app.component('MB16_TT69_ThreeYear_ViewSummary_DVCQ', MB16_TT69_ThreeYear_ViewSummary_DVCQ);
  app.component('MB16_TT69_ThreeYear_DVCQ', MB16_TT69_ThreeYear_DVCQ);
  app.component('MB13_TT69_ThreeYear_ViewSummary_DVCQ', MB13_TT69_ThreeYear_ViewSummary_DVCQ);
  app.component('MB13_TT69_ThreeYear_DVCQ', MB13_TT69_ThreeYear_DVCQ);
  app.component('MB17_TT692017_BTC_TYSummary', MB17_TT692017_BTC_TYSummary);
  app.component('MB19_TT692017_BTC_TY', MB19_TT692017_BTC_TY);
  app.component('MB19_TT692017_BTC_TYSummary', MB19_TT692017_BTC_TYSummary);
  app.component('MB18_TT692017_TT_BTC', MB18_TT692017_TT_BTC);
  app.component('MB18_TT692017_TT_BTC_Summary', MB18_TT692017_TT_BTC);
  app.component('MB13_1_TT342_STCViewSummaryAudit', MB13_1_TT342_STCViewSummaryAudit);
  app.component('MB13_1_TT342_STC', MB13_1_TT342_STC);
  app.component('MB13_1_TT342_STCQN', MB13_1_TT342_STCQN);
  app.component('MB13_1_TT342_STC_ViewEstimateSummary', MB13_1_TT342_STC_ViewEstimateSummary);
  app.component('MB14_TT69_Summary_DVCQ', MB14_TT69_Summary_DVCQ);
  app.component('MB15_TT69_Summary_DVCQ', MB15_TT69_Summary_DVCQ);
  app.component('MB35_TT342_STC', MB35_Report_TT342_STC);
  app.component('MB12_2_TT342_STC', MB12_2_TT342_STC);
  app.component('MB12_2_TT342_ViewSummary_STC', MB12_2_TT342_ViewSummary_STC);
  app.component('MB14_TT342_STC_ViewSummary', MB14_TT342_STC_ViewSummary);
  app.component('MB14_TT342_STC_ViewReport', MB14_TT342_STC_ViewReport);
  app.component('MB13_5_TT342_STC_ViewSummary', MB13_5_TT342_STC_ViewSummary);
  app.component('MB32a_STCKH_ViewReport', MB32a_STCKH_ViewReport);
  app.component('MB32a_STCKH_ViewEstimate', MB32a_STCKH_ViewEstimate);
  app.component('MB13_5_TT342_STC_TH', MB13_5_TT342_STC_TH);
  app.component('MB15_ND31_STC_TH', MB15_ND31_STC_TH);
  app.component('MB15_ND31_STC', MB15_ND31_STC);
  app.component('MB13_8_TT342_STC_ViewSummary', MB13_8_TT342_STC_ViewSummary);
  app.component('MB13_8_TT342_STC_ViewBalance', MB13_8_TT342_STC_ViewBalance);
  app.component('MB13_9_TT342_STC_ViewSummary', MB13_9_TT342_STC_ViewSummary);
  app.component('MB13_5_TT342_STC', MB13_5_TT342_STC);
  app.component('MB13_8_TT342_STC', MB13_8_TT342_STC);
  app.component('MB13_9_TT342_STC', MB13_9_TT342_STC);
  app.component('MB12_4_TT342_STC', MB12_4_TT342_STC);
  app.component('MB13_7_AuditSummary_STC', MB13_7_AuditSummary_STC);
  app.component('MB13_7_ViewSummary_AuditSummary_STC', MB13_7_ViewSummary_AuditSummary_STC);
  app.component('MB15_1_TT342_HCSN', MB15_1_TT342_HCSN);
  app.component('MB15_1_TT342_HCSN_ViewSummary', MB15_1_TT342_HCSN_ViewSummary);
  app.component('MB15_1_TT342_DVCQ_TH', MB15_1_TT342_DVCQ_TH);
  app.component('MB15_1_TT342_DVCQ_ViewExamine', MB15_1_TT342_DVCQ_ViewExamine);
  app.component('B01_STCHG', B01_STCHG);
  app.component('B02_STCHG', B02_STCHG);
  app.component('BM03_STCHGService', BM03_STCHGService);
  app.component('MB11_1_TT342_ViewReport_STC', MB11_1_TT342_STC);
  app.component('MB11_1_TT342_ViewSummary_STC', MB11_1_TT342_STC);
  app.component('MB11_1_TT342_ViewChecking_STC', MB11_1_TT342_STC);
  app.component('MB16_ND31_STC', MB16_ND31_STC);
  app.component('MB16_ND31_STC_TH', MB16_ND31_STC_TH);
  app.component('MB17_ND31_STC', MB17_ND31_STC);
  app.component('MB17_ND31_ViewSummary_STC', MB17_ND31_STC);
  app.component('MB10_ND31_2017_STC', MB10_ND31_2017_STC);
  app.component('MB07_ViewSummary_STC', MB07_ViewSummary_STC);
  app.component('MB08_ViewSummary_STC', MB08_ViewSummary_STC);
  app.component('MB09_ND31_2017_STC', MB09_ND31_2017_STC);
  app.component('MB01_THL_PTCVB', MB01_THL_PTCVB);
  app.component('MB02_PTC_VanBan', MB02_PTC_VanBan);
  app.component('MB13_7_ViewSummary_AfterEstimateSummary_STC', MB13_7_ViewSummary_AfterEstimateSummary_STC);
  app.component('MB13_9_ViewSummary_AfterEstimateSummary_STC', MB13_9_ViewSummary_AfterEstimateSummary_STC);
  app.component('MB14_TT342_STC_ViewEstimate', MB14_TT342_STC_ViewEstimate);
  app.component('MB11_ND31_NDCP_STC', MB11_ND31_NDCP_STC);
  app.component('MB11_ND31_NDCP_STC_Summary', MB11_ND31_NDCP_STC_Summary);
  app.component('MB10_ND31_2017_STC_Summary', MB10_ND31_2017_STC_Summary);
  app.component('MB09_ND31_2017_STC_Summary', MB09_ND31_2017_STC_Summary);
  app.component('MB02_TY_ViewSummary_TT69', MB02_TY_ViewSummary_TT69);
  app.component('MB03_TY_ViewSummary_TT69', MB03_TY_ViewSummary_TT69);
  app.component('MB13_5_TT342_DVCQ_Report', MB13_5_TT342_DVCQ_Report); //Mẫu 13.5 TT342 DVCQ in tại báo cáo
  app.component('MB13_5_TT342_DVCQ_Summary', MB13_5_TT342_DVCQ_Summary); //Mẫu 13.5 TT342 DVCQ view tổng hợp sau lập
  app.component('MB13_5_TT342_DVCQ_Examine', MB13_5_TT342_DVCQ_Examine); //Mẫu 13.5 TT342 DVCQ view tổng hợp sau kiểm tra
  app.component('MB13_7_ViewExam_DVCQ', MB13_7_ViewExam_DVCQ);
  app.component('MB13_7_ViewSummary_DVCQ', MB13_7_ViewSummary_DVCQ);
  app.component('MB13_7_ViewReport_DVCQ', MB13_7_ViewReport_DVCQ);
  app.component('MB14_ND31_PTC_TH', MB14_ND31_PTC_TH);
  app.component('MB11_1_TT342_ViewAudit_DVCQ', MB11_1_TT342_ViewAudit_DVCQ);
  app.component('MB13_8_TT342_ViewAudit_CQ', MB13_8_TT342_ViewAudit_CQ);
  // Biểu 12,14 stc
  app.component('MB12_ND31_ViewReport_STC', MB12_ND31_ViewReport_STC);
  app.component('MB12_ND31_ViewSummary_STC', MB12_ND31_ViewSummary_STC);
  app.component('MB14_ND31_ViewReport_STC', MB14_ND31_ViewReport_STC);
  app.component('MB14_ND31_ViewSummary_STC', MB14_ND31_ViewSummary_STC);
  app.component('MB35_ND31_ViewReport_STCKH', MB35_ND31_ViewReport_STCKH);
  app.component('MB35_ND31_ViewSummary_STCKH', MB35_ND31_ViewSummary_STCKH);
  app.component('PGDCT_01_THDT', PGDCT_01_THDT);
  app.component('MB_NSH02_PTC', MB_NSH02_PTC);
  app.component('MB_NSH02_STC', MB_NSH02_STC); 
  app.component('BM_DTKT_STC', BM_DTKT_STC);
  app.component('BM_DTKH_STC', BM_DTKH_STC);
  app.component('MB_NST01_STC', MB_NST01_STC);
  app.component('MB_NST01_SN', MB_NST01_SN);
  app.component('MB_ReportTemplateFile', MB_ReportTemplateFile);
  app.component('BM_DTTT_STC', BM_DTTT_STC);
  app.component('MB13_1_TT342_DVCQ_ViewExamine', MB13_1_TT342_DVCQ_ViewExamine);
  app.component('MB13_1_TT342_DVCQ_ViewExamine_QN', MB13_1_TT342_DVCQ_ViewExamine_QN);
  app.component('MB31_TT342_PTCKH', MB31_TT342_PTCKH);
  app.component('MB31_TT342_ViewReport_STC_KH', MB31_TT342_ViewReport_STC_KH);
  app.component('MB37_STCKhanhHoaHCSN', MB37_STCKhanhHoaHCSN);
  app.component('MB38_ND31_STCKH', MB38_ND31_STCKH);
  app.component('MB32_PTCKH_TT342', MB32_PTCKH_TT342);
  app.component('MB32_PTCKH_TT342Popup', MB32_PTCKH_TT342Popup);
  app.component('MB15_1_TML_Summary', MB15_1_TML_Summary);
  app.component('MB15_1_TML_Audit_Report', MB15_1_TML_Audit_Report);
  app.component('MBNTNNKH_CQDB', MBNTNNKH_CQDB);
  app.component('MBDTL_CQDB', MBDTL_CQDB);
  app.component('MBNBLKH_CQDB', MBNBLKH_CQDB);
  app.component('MBNBLHH_CQDB', MBNBLHH_CQDB);
  app.component('MBNTNNHH_CQDB', MBNTNNHH_CQDB);
  app.component('MB15_1_TML_Submit', MB15_1_TML_Submit);
  app.component('MB15_1_TML_Report', MB15_1_TML_Report);
  app.component('SubmitEstimateArrgrateViewReportDVXModeExpense', SubmitEstimateArrgrateViewReportDVXModeExpense);
  app.component('MB18_LoanRepayment_STC', MB18_LoanRepayment_STC);

  app.component('RequestDetailHCSNReportInitial', RequestDetailHCSNReportInitial);
  app.component('MB37_STCKhanhHoa', MB37_STCKhanhHoa);
  app.component('MB30_LoanRepayment_STC', MB30_LoanRepayment_STC);
  app.component('MB05_LoanRepayment_TY_STC', MB05_LoanRepayment_TY_STC);
  app.component('MB15_1_TML_AuditSummary', MB15_1_TML_AuditSummary);
  app.component('MB15_1_TML_SummaryArrgrate', MB15_1_TML_SummaryArrgrate);
  app.component('MB15_1_TML_SubmitArrgrate', MB15_1_TML_SubmitArrgrate);
  app.component('MB15_1_TML_AuditReceive_STC', MB15_1_TML_AuditReceive_STC);
  app.component('ExplanSalary_KH_KPTL73_STC_Audit_Dvcq', ExplanSalary_KH_KPTL73_STC_Audit_Dvcq);
  app.component('ExplanSalary_KH_KPTL73_STC_Audit_Hcsn', ExplanSalary_KH_KPTL73_STC_Audit_Hcsn);
  app.component('MB12_5_KH_TT342_HCSN', MB12_5_KH_TT342_HCSN);
  app.component('MB12_5_KH_TT342_DVCQ', MB12_5_KH_TT342_DVCQ);
  app.component('MB13_10_KH_HCSN', MB13_10_KH_HCSN);
  app.component('MB13_10_KH_DVCQ', MB13_10_KH_DVCQ);
  app.component('MB13_12_KH_Report', MB13_12_KH_Report);
}
